/**
 * GiftTiers — loyalty claim bar (manual "Reclamar regalo")
 * Mounts into [data-gifttiers-loyalty-claim] in cart drawer / main cart.
 *
 * Pack add is a single /cart/add.js with items[]. Overlay blocks checkout
 * until the full pack is confirmed in the cart (no "loading by blocks").
 */
(function GiftTiersLoyaltyClaim() {
  "use strict";

  if (window.__GiftTiersLoyaltyClaimBooted) return;
  window.__GiftTiersLoyaltyClaimBooted = true;

  var LOG = "[GiftTiers claim]";
  var DEBUG = false;
  try {
    DEBUG =
      /(?:\?|&)gifttiers_debug=1(?:&|$)/.test(String(location.search || "")) ||
      window.localStorage.getItem("gifttiers_debug") === "1";
  } catch (_) {}

  function log() {
    if (!DEBUG) return;
    try {
      console.info.apply(console, [LOG].concat([].slice.call(arguments)));
    } catch (_) {}
  }

  function money(n) {
    var v = Number(n) || 0;
    try {
      return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR",
      }).format(v);
    } catch (_) {
      return v.toFixed(2) + " €";
    }
  }

  function normalizeId(id) {
    if (id == null) return "";
    var s = String(id);
    var m = s.match(/\/(\d+)$/);
    return m ? m[1] : s.trim();
  }

  function getContext() {
    return window.GiftTierContext || {};
  }

  function isLoyaltyGift(props) {
    if (!props) return false;
    var g = props._is_gift || props.is_gift;
    var isGift = g === true || g === "true" || g === "1" || g === 1;
    return isGift && !!props._gift_loyalty_offer_id;
  }

  function isAnyGift(props) {
    if (!props) return false;
    var v = props._is_gift || props.is_gift;
    return v === true || v === "true" || v === "1" || v === 1;
  }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" }).then(function (r) {
      if (!r.ok) throw new Error("cart " + r.status);
      return r.json();
    });
  }

  function regularCartValue(cart) {
    var ctx = getContext();
    if (
      window.GiftTiersCartValue &&
      typeof window.GiftTiersCartValue.regularCartValue === "function"
    ) {
      return window.GiftTiersCartValue.regularCartValue(cart, {
        isGift: function (props) {
          if (!props) return false;
          var v = props._is_gift || props.is_gift;
          return v === true || v === "true" || v === "1" || v === 1;
        },
        context: ctx,
      });
    }
    return (
      (cart.items || [])
        .filter(function (i) {
          var p = i.properties || {};
          var v = p._is_gift || p.is_gift;
          return !(v === true || v === "true" || v === "1" || v === 1);
        })
        .reduce(function (s, i) {
          return s + Number(i.final_line_price || i.line_price || 0);
        }, 0) / 100
    );
  }

  function loyaltyLinesInCart(cart, data) {
    var claimVariants = {};
    ((data && data.items) || []).forEach(function (it) {
      claimVariants[normalizeId(it.giftVariantId)] = true;
    });
    return (cart.items || []).filter(function (i) {
      if (isLoyaltyGift(i.properties)) return true;
      if (isAnyGift(i.properties) && claimVariants[normalizeId(i.variant_id)]) {
        return true;
      }
      return false;
    });
  }

  /** Variants from the desired pack that are missing (or under-qty) in cart. */
  function missingPackItems(cart, offerId, items) {
    var byVariant = {};
    (cart.items || []).forEach(function (line) {
      if (!isAnyGift(line.properties)) return;
      var vid = normalizeId(line.variant_id);
      byVariant[vid] = (byVariant[vid] || 0) + Number(line.quantity || 0);
    });
    var missing = [];
    (items || []).forEach(function (it) {
      var vid = normalizeId(it.giftVariantId);
      var need = Math.max(1, Number(it.quantity || 1));
      var have = byVariant[vid] || 0;
      if (have < need) {
        missing.push({
          giftVariantId: it.giftVariantId,
          quantity: need - have,
          giftProductTitle: it.giftProductTitle,
        });
      }
    });
    return missing;
  }

  /**
   * Use the same drawer/page spinner as newgarden-theme (cart-settle),
   * not a full-screen black overlay.
   */
  function setSettling(on) {
    var cl = document.documentElement.classList;
    if (on) {
      cl.remove("cart-settle-leaving");
      cl.add("cart-settling");
      document.querySelectorAll(
        'button[name="checkout"], .checkout-button, [name="checkout"]'
      ).forEach(function (btn) {
        btn.disabled = true;
        btn.setAttribute("data-gt-claim-locked", "1");
      });
    } else {
      // Let cart-settle finish its own quiet cycle if it's managing the episode.
      if (window.__cartSettle && window.__cartSettle.isBusy && window.__cartSettle.isBusy()) {
        /* keep cart-settling until settle ends */
      } else {
        cl.add("cart-settle-leaving");
        cl.remove("cart-settling");
        setTimeout(function () {
          cl.remove("cart-settle-leaving");
        }, 300);
      }
      document.querySelectorAll('[data-gt-claim-locked="1"]').forEach(function (btn) {
        btn.disabled = false;
        btn.removeAttribute("data-gt-claim-locked");
      });
    }
  }

  function addGiftItems(offerId, items) {
    var payload = {
      items: items.map(function (it) {
        var qty = Math.max(1, Number(it.quantity || 1));
        return {
          id: Number(normalizeId(it.giftVariantId)),
          quantity: qty,
          properties: {
            _is_gift: "true",
            _gift_loyalty_offer_id: String(offerId),
            _gift_max_uses: String(qty),
          },
        };
      }),
    };
    log("claim add (batch)", payload);
    window.__GiftTiersClaimAddLock = true;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) {
            var msg =
              (body && (body.description || body.message)) ||
              "No se pudo añadir el regalo";
            throw new Error(msg);
          }
          return body;
        });
      })
      .finally(function () {
        window.__GiftTiersClaimAddLock = false;
      });
  }

  /**
   * Add pack in one request, then verify; fill any missing lines in a second
   * single batch (inventory / partial failures). Never add line-by-line.
   */
  function applyFullPack(offerId, items) {
    return addGiftItems(offerId, items).then(function () {
      return fetchCart().then(function (cart) {
        var missing = missingPackItems(cart, offerId, items);
        if (!missing.length) {
          log("pack complete after first add");
          return cart;
        }
        log("pack incomplete — batch fill missing", missing);
        return addGiftItems(offerId, missing).then(function () {
          return fetchCart().then(function (cart2) {
            var still = missingPackItems(cart2, offerId, items);
            if (still.length) {
              throw new Error(
                "No se pudieron añadir todos los productos del pack. Revisa stock e inténtalo de nuevo."
              );
            }
            return cart2;
          });
        });
      });
    });
  }

  function notifyCartUpdated() {
    try {
      document.dispatchEvent(
        new CustomEvent("gifttiers:loyalty-claimed", {
          detail: { source: "gifttiers-loyalty-claim" },
        })
      );
    } catch (_) {}
    try {
      if (typeof window.refreshCart === "function") window.refreshCart();
      if (window.theme && typeof window.theme.refreshCart === "function") {
        window.theme.refreshCart();
      }
    } catch (_) {}
    // Force a full cart page paint if we're on /cart (SSR sections lag otherwise).
    try {
      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { source: "gifttiers-loyalty-claim" },
        })
      );
    } catch (_) {}
  }

  function checkEligibility(cartValue) {
    var ctx = getContext();
    var ep = ctx.loyaltyGiftEndpoint || "/apps/gifttiers/loyalty-gift-check";
    return fetch(ep, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shop-Domain": ctx.shop || "",
      },
      credentials: "same-origin",
      body: JSON.stringify({
        shop: ctx.shop,
        customerId: ctx.customerId,
        cartValue: cartValue,
        customerTags: ctx.customerTags || [],
        loyaltyRedeemed: String(window.GiftTierLoyaltyRedeemed || ctx.loyaltyRedeemed || ""),
      }),
    }).then(function (r) {
      if (!r.ok) throw new Error("loyalty-check " + r.status);
      return r.json();
    });
  }

  function progressPercent(cartValue, tiers) {
    if (!tiers || !tiers.length) return 0;
    var max = Number(tiers[tiers.length - 1].minCartValue || 0);
    if (max <= 0) return 100;
    return Math.max(0, Math.min(100, (cartValue / max) * 100));
  }

  function render(root, state) {
    var data = state.data;
    var cart = state.cart;
    var claiming = state.claiming;
    var error = state.error;

    if (!data || data.redeemed) {
      root.hidden = true;
      root.innerHTML = "";
      return;
    }

    var tiers = data.tiers || [];
    if (!tiers.length && !data.claimable) {
      root.hidden = true;
      root.innerHTML = "";
      return;
    }

    root.hidden = false;
    var claimed = loyaltyLinesInCart(cart, data);
    var packMissing = missingPackItems(cart, data.offerId, data.items || []);
    var alreadyClaimed = claimed.length > 0 && packMissing.length === 0;
    var cartValue = Number(data.cartValue || 0);
    var pct = progressPercent(cartValue, tiers);
    var claimable = !!data.claimable && !alreadyClaimed;
    var qty = (data.items || []).reduce(function (s, it) {
      return s + Math.max(1, Number(it.quantity || 1));
    }, 0);
    var title =
      (data.items && data.items[0] && data.items[0].giftProductTitle) ||
      "Regalo fidelización";

    var markers = tiers
      .map(function (t) {
        var left = progressPercent(t.minCartValue, tiers);
        var unlocked = !!t.unlocked;
        return (
          '<span class="gt-claim__mark' +
          (unlocked ? " is-unlocked" : "") +
          '" style="left:' +
          left +
          '%" title="' +
          money(t.minCartValue) +
          " · ×" +
          t.quantity +
          '"><i></i><em>' +
          money(t.minCartValue) +
          "</em></span>"
        );
      })
      .join("");

    var statusHtml = "";
    if (alreadyClaimed) {
      statusHtml =
        '<p class="gt-claim__status is-ok">Regalo reclamado (' +
        claimed.reduce(function (s, i) {
          return s + i.quantity;
        }, 0) +
        " uds).</p>";
    } else if (claimable && claimed.length > 0 && packMissing.length > 0) {
      statusHtml =
        '<p class="gt-claim__status">Completando pack… faltan productos del regalo.</p>';
    } else if (claimable) {
      statusHtml =
        '<p class="gt-claim__status">¡Has desbloqueado <strong>' +
        qty +
        "×</strong> " +
        escapeHtml(shortTitle(title)) +
        "!</p>";
    } else if (data.nextTier) {
      statusHtml =
        '<p class="gt-claim__status">Te faltan <strong>' +
        money(data.nextTier.remaining) +
        "</strong> para el siguiente regalo.</p>";
    } else {
      statusHtml = '<p class="gt-claim__status">Añade productos para desbloquear tu regalo.</p>';
    }

    var btnHtml = "";
    if (claimable) {
      btnHtml =
        '<button type="button" class="gt-claim__btn"' +
        (claiming ? " disabled" : "") +
        ">" +
        (claiming ? "Aplicando pack…" : claimed.length ? "Completar pack" : "Reclamar regalo") +
        "</button>";
    } else if (alreadyClaimed) {
      btnHtml = '<button type="button" class="gt-claim__btn is-done" disabled>Reclamado</button>';
    }

    root.innerHTML =
      '<div class="gt-claim__card">' +
      '<div class="gt-claim__head"><span class="gt-claim__label">Regalo fidelización</span>' +
      '<span class="gt-claim__value">' +
      money(cartValue) +
      "</span></div>" +
      '<div class="gt-claim__bar"><div class="gt-claim__fill" style="width:' +
      pct +
      '%"></div>' +
      '<div class="gt-claim__marks">' +
      markers +
      "</div></div>" +
      statusHtml +
      (error ? '<p class="gt-claim__error">' + escapeHtml(error) + "</p>" : "") +
      btnHtml +
      "</div>";

    var btn = root.querySelector(".gt-claim__btn:not(.is-done)");
    if (btn && claimable) {
      btn.addEventListener("click", function () {
        claim(root, data);
      });
    }
  }

  function shortTitle(t) {
    var s = String(t || "");
    var cut = s.indexOf("—");
    if (cut > 0) s = s.slice(0, cut);
    cut = s.indexOf(" - ");
    if (cut > 0) s = s.slice(0, cut);
    return s.trim();
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  var claiming = false;

  function claim(root, data) {
    if (claiming || !data || !data.offerId || !(data.items || []).length) return;
    if (window.__GiftTiersClaimInFlight) return;
    window.__GiftTiersClaimInFlight = true;
    claiming = true;
    setSettling(true);
    render(root, { data: data, cart: { items: [] }, claiming: true, error: null });

    fetchCart()
      .then(function (cart) {
        var missing = missingPackItems(cart, data.offerId, data.items);
        if (!missing.length && loyaltyLinesInCart(cart, data).length) {
          log("claim abort — full pack already in cart");
          return cart;
        }
        return applyFullPack(data.offerId, missing.length ? missing : data.items);
      })
      .then(function () {
        notifyCartUpdated();
        return new Promise(function (resolve) {
          setTimeout(resolve, 700);
        }).then(function () {
          return refreshAll();
        });
      })
      .catch(function (err) {
        claiming = false;
        window.__GiftTiersClaimInFlight = false;
        setSettling(false);
        refreshAll(err && err.message ? err.message : "Error al reclamar");
      })
      .then(function () {
        claiming = false;
        window.__GiftTiersClaimInFlight = false;
        setSettling(false);
      });
  }

  function refreshAll(errorMsg) {
    var roots = document.querySelectorAll("[data-gifttiers-loyalty-claim]");
    if (!roots.length) return Promise.resolve();
    var ctx = getContext();
    if (!ctx.customerId) {
      roots.forEach(function (r) {
        r.hidden = true;
        r.innerHTML = "";
      });
      return Promise.resolve();
    }

    return fetchCart()
      .then(function (cart) {
        var value = regularCartValue(cart);
        return checkEligibility(value).then(function (data) {
          roots.forEach(function (root) {
            render(root, {
              data: data,
              cart: cart,
              claiming: claiming,
              error: errorMsg || null,
            });
          });
        });
      })
      .catch(function (err) {
        log("refresh error", err);
      });
  }

  var timer = null;
  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      refreshAll();
    }, typeof ms === "number" ? ms : 250);
  }

  function boot() {
    log("boot");
    schedule(120);
    schedule(800);
    [
      "cart-drawer:open",
      "cart:refresh",
      "cart:item-added",
      "line-item:change:end",
      "cart:updated",
      "theme:cart:updated",
    ].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (e && e.detail && e.detail.source === "gifttiers-loyalty-claim") {
          schedule(400);
          return;
        }
        schedule(280);
      });
    });
  }

  window.GiftTiersLoyaltyClaim = {
    refresh: refreshAll,
    claimFromData: function (data) {
      var root = document.querySelector("[data-gifttiers-loyalty-claim]");
      if (root && data) claim(root, data);
    },
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
